module.exports = __webpack_public_path__ + "static/logo-universite-laval-cbf2a3a68718d727e950bf80cdbe9554.svg";